export default "__VITE_ASSET__7$uRWSHi__"